module.exports = __webpack_public_path__ + "img/p1-desc.ec5845ed.jpg";